import { render, staticRenderFns } from "./tariffRecords.vue?vue&type=template&id=c3a7b57a&scoped=true&"
import script from "./tariffRecords.vue?vue&type=script&lang=js&"
export * from "./tariffRecords.vue?vue&type=script&lang=js&"
import style0 from "./tariffRecords.vue?vue&type=style&index=0&id=c3a7b57a&lang=scss&scoped=true&"
import style1 from "./tariffRecords.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3a7b57a",
  null
  
)

export default component.exports